import { defineStore } from 'pinia';
export const useStore = defineStore('main', {
    state: () => ({
        altId: '',
        altType: '',
        allowedExtensions: [],
        maxUploadSize: {
            image: 100000000,
            document: 100000000,
            video: 4000000000,
            audio: 100000000,
        },
        application: 'media-center',
        appState: '',
        fileList: [],
        currentPath: '',
        uploadQueue: [],
        activeItem: {},
        tokenId: '',
        directoryRoute: [],
        apiKey: '',
        retryCount: 0,
        selfHosted: false,
        contentAIEnable: false,
        loading: true,
        mediaModal: false,
        activeCategory: 'my_media',
        previewItem: {},
    }),
    actions: {
        updateFilesList(payload) {
            const { currentPath, fileList } = payload;
            this.fileList = fileList;
            this.currentPath = currentPath;
        },
        addToUploadQueue(newItem) {
            this.uploadQueue.push(newItem);
        },
        updateUploadQueue(id, url) {
            const idxFile = this.uploadQueue.findIndex((x) => x.id === id);
            this.uploadQueue[idxFile].uploaded = true;
            this.uploadQueue[idxFile].url = url;
        },
        cleanUploadQueueHistory() {
            this.uploadQueue = this.uploadQueue.filter(x => !x.uploaded);
        },
        updateActiveObject(item) {
            var _a;
            if (((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a._id) === item._id) {
                this.activeItem = {};
                return;
            }
            this.activeItem = item;
        },
        updateActiveExternalObject(item) {
            var _a;
            if (((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a._id) === item.id) {
                this.activeItem = {};
                return;
            }
            this.activeItem = item;
            this.activeItem._id = item.id;
        },
        updateDirectory(item) {
            if (!item)
                this.directoryRoute = [];
            else
                this.directoryRoute.push(item);
        },
        updateMetaInfo(param) {
            this.altId = param.altId;
            this.altType = param.altType;
            this.allowedExtensions = param.allowedExtensions;
            this.maxUploadSize = param.maxUploadSize;
            // this.appState = param.appState
            this.selfHosted = param.selfHosted || false;
            this.contentAIEnable =
                (param === null || param === void 0 ? void 0 : param.contentAIEnableByUser) && (param === null || param === void 0 ? void 0 : param.contentAIEnableInLocation);
        },
        updateRetryCount(count) {
            this.retryCount = count;
        },
        updateToken(token) {
            this.tokenId = token;
        },
        updateActiveCategory(payload) {
            this.activeCategory = payload;
        },
        updatePreviewItem(payload) {
            this.previewItem = payload;
        },
    },
});
